var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("FacebookLogin"),
      _c(
        "div",
        { staticClass: "action-bar my-4" },
        [
          _vm.$store.state.loginStatus === true
            ? _c("router-link", {
                staticClass: "keyloopButton textUppercase",
                attrs: { to: "Install", tag: "button", id: "loginNext" },
                domProps: { innerHTML: _vm._s(_vm.$t("global.next")) },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }